import React, { useState, useEffect } from 'react';
import useAuth from '../../../../features/hooks/useAuth';
import UnivConReqComp from '../UnivConReqComp';
import { consumInboxTags } from './consumInboxTags';


const ConsumInboxTable = ({ subTabValue, handleEditclick }) => {
  const Auth = useAuth();
  const [limit, setLimit] = useState(5);
  const [lastId, setLastId] = useState(null);
  const [filterProps, setFilterProps] = useState({}); 

  useEffect(() => {
    if (!Auth?.id) return;

    let updatedFilterProps = {};
    let sento_tags_filter = [];

    sento_tags_filter = consumInboxTags[subTabValue] || [];
  
     console.log("Current subTabValue:", subTabValue, "Type:", typeof subTabValue);

    // Check if subTabValue is EXACTLY 5, not just truthy comparison
    if(Number(subTabValue) === 5) {
      console.log("Entered Closed Tab Filter - subTabValue is 4");
      // For closed tab, use perm_flow_users instead of perm_curr_sent_to
      updatedFilterProps = {
        perm_flow_users: [Auth.id],
        perm_curr_sent_to_tag: sento_tags_filter?.length ? sento_tags_filter : ["Not Applicable"],
      };
    } else {
      console.log("Entered Regular Inbox Filter - subTabValue is NOT 4");
      updatedFilterProps = {
        perm_curr_sent_to: [Auth.id],
        perm_curr_sent_to_tag: sento_tags_filter?.length ? sento_tags_filter : ["Not Applicable"],
      };
    }
  
    console.log("Updated Filter Props:", updatedFilterProps);
    setFilterProps(updatedFilterProps);

  }, [Auth?.id, subTabValue]);

console.log(filterProps)

  const columnFilter = [
    "UniqueReqId", "Req_Type", "Req_Creator", "Store", "Curr_Status", "Created_At",
    "Currently_With", "Status", "Action"
  ];

  return (
    <>
      <UnivConReqComp
        filterProps={filterProps}  
        columnFilter={columnFilter}
        handleEditclick={handleEditclick}
        limit={limit} 
        setLimit={setLimit} 
        lastId={lastId} 
        setLastId={setLastId}
        viewType="inbox"
      />    
    </>
  );
};

export default ConsumInboxTable; 